
// src/components/checagens/NovaTarefaModal.tsx
import React, { useState } from 'react';
import { useCreateTarefa } from '../../hooks/useChecagens';
import { TipoTarefa } from '../../models/checagens';
import './NovaTarefaModal.css';

interface NovaTarefaModalProps {
  checagemImovelId: number;
  onClose: () => void;
}

const NovaTarefaModal: React.FC<NovaTarefaModalProps> = ({ checagemImovelId, onClose }) => {
  const [titulo, setTitulo] = useState('');
  const [descricao, setDescricao] = useState('');
  const [dueAt, setDueAt] = useState('');
  const [tipo, setTipo] = useState<TipoTarefa>('followup');
  const createTarefaMutation = useCreateTarefa();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    createTarefaMutation.mutate(
      { ciId: checagemImovelId, data: { titulo, tipo, status: 'pendente', descricao, due_at: dueAt ? new Date(dueAt) : undefined } },
      { onSuccess: onClose }
    );
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Nova Tarefa</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Título</label>
            <input type="text" value={titulo} onChange={e => setTitulo(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Descrição</label>
            <textarea value={descricao} onChange={e => setDescricao(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Data de Vencimento</label>
            <input type="datetime-local" value={dueAt} onChange={e => setDueAt(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Tipo</label>
            <select value={tipo} onChange={e => setTipo(e.target.value as TipoTarefa)}>
              <option value="ligacao">Ligação</option>
              <option value="email">Email</option>
              <option value="whatsapp">WhatsApp</option>
              <option value="visita">Visita</option>
              <option value="followup">Follow-up</option>
            </select>
          </div>
          <div className="modal-actions">
            <button type="button" onClick={onClose}>Cancelar</button>
            <button type="submit" disabled={createTarefaMutation.isPending}>Salvar</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NovaTarefaModal;
